module.exports = __webpack_public_path__ + "img/img_thank_you.2b6291ba.png";